import './image-combination.scss';

import { OverlaySlider } from '../../utilities/js/overlay-slider';

class ImageCombination {
    constructor (element, options) {
        const defaults = {
            mobile: false,
            onUpdated: null
        };

        this.settings = Object.assign({}, defaults, options);
        this.$imageCombination = element;
    }

    initialize () {
        this.initOverlay(this.$imageCombination);
    }

    initOverlay ($obj) {
        // init overlay slider
        // eslint-disable-next-line no-new
        new OverlaySlider($obj);
    }
}

export { ImageCombination };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$ImageCombination = $context.querySelectorAll('[data-image-combination="root"]');
        for (let i = 0; i < $$ImageCombination.length; i++) {
            const $ImageCombination = new ImageCombination($$ImageCombination[i]);
            $ImageCombination.initialize();
        }
    }
});
